module.exports = __webpack_public_path__ + "static/media/494a9340-2b09-4558-b1d6-6c5966ead957.3b2a19ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/494a9340-2b09-4558-b1d6-6c5966ead957.svg
// module id = 107
// module chunks = 0